import { render, staticRenderFns } from "./ContenedorCampos.vue?vue&type=template&id=4e550d33&scoped=true"
import script from "./ContenedorCampos.vue?vue&type=script&lang=js"
export * from "./ContenedorCampos.vue?vue&type=script&lang=js"
import style0 from "./ContenedorCampos.vue?vue&type=style&index=0&id=4e550d33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e550d33",
  null
  
)

export default component.exports